export class AppShortUrlUtil {
  private static readonly SHORT_DOMAIN_O7: string = "https://o7n.co";
  private static readonly SHORT_DOMAIN_HDS: string = "https://hyds.app";

  static getShortDomain(hyperDotStudios: boolean) {
    return hyperDotStudios ? this.SHORT_DOMAIN_HDS : this.SHORT_DOMAIN_O7;
  }
}
